import React, { useState, useEffect } from "react";
import { Col, Form, Modal, Row, Image, Button } from "react-bootstrap";
import { TextField, FormControl, Select } from "@material-ui/core";
import Switch from "react-switch";
import moment from "moment";
import InputNumberFunc from "../../../../../function/InputNumberFunc";
import isEmpty from "../../../../../store/validation/is-Empty";
import { vendor_dashboard_edit_action } from "../../../../../store/actions/dashboardAction/addingAction";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  getUserDetailsFromUserId,
  getUserDetailsByType,
} from "../../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
const EditDiner = ({
  onClickshowEdit,
  onClickCloseEdit,
  userData,
  vendor_dashboard_edit_action,
  getUserDetailsFromUserId,
  getUserDetailsByType,
  auth,
  ...props
}) => {
  //state
  const [state, setState] = useState({
    code: "+91",
    number: "",
    name: "",
    highChairHandiCapped: false,
    roomNumber: "",
    tableNumber: "",
    specialOcassion: "",
    seating_preference: "",
  });

  const [adult, setAdult] = useState(0);
  const [kids, setKids] = useState(0);
  const [handicap, setHandicap] = useState(0);
  const [highchair, setHighchair] = useState(0);
  const [seatingPreference, setSeatingPreference] = useState([]);
  const { userId } = useParams();
  const onChange = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };

  const onChangeSeatingPreference = (title) => {
    setState({ ...state, seating_preference: title });
  };

  const handleChangeCode = (event) => {
    const code = event.target.name;
    setState({
      ...state,
      [code]: event.target.value,
    });
  };
  const [checkedBox, setCheckedBox] = useState(false);

  const handleChangeSwitch = (e) =>
    setCheckedBox({ checkedBox: !checkedBox.checkedBox });
  const calcTotalPersons = (seating) => {
    let total;
    total =
      seating.adult_count +
      seating.kids_count +
      seating.high_chair +
      seating.handicap_chair;
    return total;
  };

  const IncrementKidsItem = (e) => {
    e.preventDefault();
    if (adult === 0) {
      if (kids < 100) {
        setKids(kids + 1);
        setAdult(adult + 1);
      } else {
        setKids(kids + 1);
      }
    } else {
      setKids(kids + 1);
    }
  };
  const IncrementAdultItem = (e) => {
    e.preventDefault();
    if (adult < 100) {
      setAdult(adult + 1);
    } else {
      return null;
    }
  };
  const IncrementhandicapItem = (e) => {
    e.preventDefault();
    if (handicap < 100) {
      setHandicap(handicap + 1);
    } else {
      return null;
    }
  };
  const IncrementhighchairItem = (e) => {
    e.preventDefault();
    if (highchair < 100) {
      setHighchair(highchair + 1);
    } else {
      return null;
    }
  };

  const DecreaseKidsItem = (e) => {
    e.preventDefault();
    if (kids > 0) {
      setKids(kids - 1);
    } else {
      return null;
    }
  };

  const DecreaseAdultItem = (e) => {
    e.preventDefault();
    if (adult > 0) {
      setAdult(adult - 1);
    } else {
      return null;
    }
  };

  const DecreaseHandicapItem = (e) => {
    e.preventDefault();
    if (handicap > 0) {
      setHandicap(handicap - 1);
    } else {
      return null;
    }
  };
  const DecreaseHighchairItem = (e) => {
    e.preventDefault();
    if (highchair > 0) {
      setHighchair(highchair - 1);
    } else {
      return null;
    }
  };

  const onClickUpdate = () => {
    const formData = {
      kids_count: kids,
      adult_count: adult,
      handicap_chair: handicap,
      high_chair: highchair,
      occasion: state.specialOcassion,
      seating_preference: state.seating_preference,
      room_number: state.roomNumber,
      table_number: state.tableNumber,
    };
    const token = auth.user.accessToken;
    vendor_dashboard_edit_action(formData, userData._id, token, onSuccess);
  };

  const onSuccess = () => {
    onClickCloseEdit();
    props.getData();
    // getUserDetailsFromUserId(userId, onSuccessLoadData);
  };

  const onSuccessLoadData = () => {
    onClickCloseEdit();
  };
  const onChangeNumber = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    setState({
      ...state,
      [e.target.name]: number,
    });
  };

  useEffect(() => {
    if (
      userData &&
      userData.restaurant_id &&
      userData.restaurant_id.selected_seating_area
    )
      setSeatingPreference(userData.restaurant_id.selected_seating_area);
    setAdult(
      !isEmpty(userData && userData.adult_count) ? userData.adult_count : 0
    );
    setKids(
      !isEmpty(userData && userData.kids_count) ? userData.kids_count : 0
    );
    setHandicap(
      !isEmpty(userData && userData.handicap_chair)
        ? userData.handicap_chair
        : 0
    );
    setHighchair(
      !isEmpty(userData && userData.high_chair) ? userData.high_chair : 0
    );
    setCheckedBox({
      checkedBox:
        (userData && userData.handicap_chair) ||
        (userData && userData.high_chair === 0)
          ? false
          : true,
    });
    setState({
      ...state,
      seating_preference:
        userData &&
        userData.seating_preference &&
        userData.seating_preference[0],
      specialOcassion: userData && userData.occasion,
      roomNumber: userData && userData.room_number,
      tableNumber: userData && userData.table_number,
    });
  }, [userData]);
  return (
    <>
      <Modal
        show={onClickshowEdit}
        onHide={onClickCloseEdit}
        centered
        size="lg"
      >
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f24-700">Edit Diner</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-md-4">
          <Form className="row">
            <Col md={12}>
              <div className="d-flex align-items-center pb-4">
                <div className="enIMG97">
                  <Image
                    src={
                      userData &&
                      userData.restaurant_id &&
                      userData.restaurant_id.logo_url
                    }
                    alt="restaurant logo"
                    title="restaurant logo"
                    className="w-100 h-100"
                  />
                </div>
                <div className="pl-3">
                  <div className="f30-700">
                    {userData &&
                      userData.restaurant_id &&
                      userData.restaurant_id.restaurant_name}
                  </div>
                  <div className="f19-500 opacity5">
                    {userData &&
                      userData.restaurant_id &&
                      userData.restaurant_id.restaurant_address}
                  </div>
                </div>
              </div>
              <div className="enGrayBorderBox enLeftGReenLine mb-4">
                <Row className="px-3">
                  <Col lg={3} md={6} className="py-3">
                    <div className="f12-500 pb-3">Name/Request Number</div>
                    <div className="d-flex">
                      <div>
                        <Image
                          src={require("../../../../../assets/images/UserManagement/walkin.svg")}
                          alt="View"
                          title="View"
                          width="9px"
                        />
                      </div>
                      <div className="pl-2">
                        <div className="f15-500">
                          {" "}
                          {userData &&
                            userData.user_details &&
                            userData.user_details.name}
                        </div>
                        <div className="f9-400">
                          #{userData && userData.diner_id}
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={3} md={6} className="py-3">
                    <div className="f12-500 pb-3">Total PAX</div>
                    <div className="adult-total-box">
                      <div className="d-flex align-items-center">
                        <p className="f18-700 text-dark mr-2">
                          {" "}
                          {userData && userData.adult_count ? (
                            calcTotalPersons(userData)
                          ) : (
                            <> </>
                          )}
                        </p>
                        <div className="adult-total-box-two mr-2">
                          <div className="d-flex align-items-center justify-content-around mb-2">
                            <div className="adult-total-box-two-insideone">
                              <Image
                                src={require("../../../../../assets/images/ActionImages/employees.png")}
                                fluid
                                alt="Adult"
                                title="Adult"
                                className="icon-image"
                              />
                            </div>
                            <span className="pl-1">
                              {" "}
                              {userData && userData.adult_count}
                            </span>
                          </div>
                          <div className="d-flex align-items-center justify-content-around">
                            <div className="adult-total-box-two-insideone">
                              <Image
                                src={require("../../../../../assets/images/ActionImages/children.png")}
                                fluid
                                alt="Children"
                                title="Children"
                                className="icon-image"
                              />
                            </div>
                            <span className="pl-1">
                              {" "}
                              {userData && userData.kids_count}
                            </span>
                          </div>
                        </div>
                        <div className="adult-total-box-three">
                          <div className="d-flex align-items-center justify-content-around mb-2">
                            <div className="adult-total-box-three-insideone">
                              <Image
                                src={require("../../../../../assets/images/ActionImages/highchair.png")}
                                fluid
                                alt="Highchair"
                                title="Highchair"
                                className="icon-image-small"
                              />
                            </div>
                            <span className="pl-1">
                              {" "}
                              {userData && userData.high_chair}
                            </span>
                          </div>
                          <div className="d-flex align-items-center justify-content-around">
                            <div className="adult-total-box-three-insideone">
                              <Image
                                src={require("../../../../../assets/images/ActionImages/wheelchair.png")}
                                fluid
                                alt="Wheel Chair"
                                title="Wheel Chair"
                                className="icon-image-small"
                              />
                            </div>
                            <span className="pl-1">
                              {" "}
                              {userData && userData.handicap_chair}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={3} md={6} className="py-3">
                    <div className="f12-500 pb-3">Seating Preference</div>
                    <div className="f12-400">
                      {userData && userData.seating_preference}
                    </div>
                  </Col>
                </Row>
                <hr className="m-0" />
                <Row className="px-3">
                  <Col lg={3} md={6} className="py-3">
                    <div className="f12-500 pb-3">Date & Time</div>
                    <div className="f12-400">
                      {" "}
                      {moment(userData && userData.createdAt).format(
                        "Do MMM, YY"
                      )}
                    </div>
                    <div className="f12-400">
                      {" "}
                      {moment(userData && userData.createdAt).format("LT")}
                    </div>
                  </Col>
                  <Col lg={3} md={6} className="py-3">
                    <div className="f12-500 pb-3">Table / Room No.</div>
                    <div className="f12-400">Outdoor /</div>
                    <div className="f12-400">
                      Table No. - {userData && userData.table_number}
                    </div>
                    <div className="f12-400">
                      Room No. - {userData && userData.room_number}
                    </div>
                  </Col>
                  <Col lg={3} md={6} className="py-3">
                    <div className="f12-500 pb-3">Special Occasion</div>
                    <div className="f12-400">
                      {userData && userData.ocassion}
                    </div>
                    {/* <Button variant="link" className="text-red f12-400 p-0">
                      See more
                    </Button> */}
                  </Col>
                  <Col lg={3} md={6} className="py-3">
                    <div className="f12-500 pb-3">Status / Location</div>
                    <div className="f13-400">
                      <span className="enYellowDot mr-1"></span>Not Seated
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col md={6}>
              <Row>
                <Col xs={4} className="pr-0">
                  <Form.Group controlId={"country_code"}>
                    <FormControl variant="outlined" className="w-100">
                      <Select
                        value={state.code}
                        disabled
                        onChange={handleChangeCode}
                        inputProps={{
                          name: "code",
                        }}
                      >
                        <option value={"+91"}>+91</option>
                      </Select>
                    </FormControl>
                  </Form.Group>
                </Col>
                <Col xs={8}>
                  <Form.Group>
                    <TextField
                      id="outlined-basic"
                      label="Phone Number"
                      variant="outlined"
                      className="w-100"
                      disabled
                      value={
                        userData &&
                        userData.user_details &&
                        userData.user_details.mobile_number
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Form.Group>
                <TextField
                  id="outlined-basic"
                  label="Name"
                  variant="outlined"
                  className="w-100"
                  disabled
                  value={
                    userData &&
                    userData.user_details &&
                    userData.user_details.name
                  }
                />
              </Form.Group>
            </Col>
            <Col md={12} lg={8}>
              <div className="f16-500 py-3">Party Size</div>
              <div className="d-flex enPartySize">
                <div className="d-flex pr-3 pb-3">
                  <div className="enKidsIcon">
                    <Image
                      src={require("../../../../../assets/images/ActionImages/children.png")}
                      alt="View"
                      title="View"
                      width="9px"
                    />
                  </div>
                  <div className="pl-md-2 enPartyPersonEdit">
                    <div className="f14-500 pb-2">Kids</div>
                    <div className="d-flex align-items-center">
                      <Button
                        variant="link"
                        className="p-0"
                        onClick={DecreaseKidsItem}
                      >
                        <Image
                          src={require("../../../../../assets/images/UserManagement/minus.svg")}
                          alt="Minus"
                          title="Minus"
                          fluid
                        />
                      </Button>
                      <input
                        placeholder="00"
                        className="enInputValueOnly f12-700"
                        value={kids}
                        readOnly
                      />
                      <Button
                        variant="link"
                        className="p-0"
                        onClick={IncrementKidsItem}
                      >
                        <Image
                          src={require("../../../../../assets/images/UserManagement/plus.svg")}
                          alt="Minus"
                          title="Minus"
                          fluid
                        />
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="d-flex border-left pl-3 pb-3">
                  <div className="enKidsIcon">
                    <Image
                      src={require("../../../../../assets/images/ActionImages/employees.png")}
                      alt="View"
                      title="View"
                      width="9px"
                    />
                  </div>
                  <div className="pl-md-2 enPartyPersonEdit">
                    <div className="f14-500 pb-2">Adult</div>
                    <div className="d-flex align-items-center">
                      <Button
                        variant="link"
                        className="p-0"
                        onClick={DecreaseAdultItem}
                      >
                        <Image
                          src={require("../../../../../assets/images/UserManagement/minus.svg")}
                          alt="Minus"
                          title="Minus"
                          fluid
                        />
                      </Button>
                      <input
                        placeholder="00"
                        className="enInputValueOnly f12-700"
                        value={adult}
                        readOnly
                      />
                      <Button
                        variant="link"
                        className="p-0"
                        onClick={IncrementAdultItem}
                      >
                        <Image
                          src={require("../../../../../assets/images/UserManagement/plus.svg")}
                          alt="Minus"
                          title="Minus"
                          fluid
                        />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <>
                {(userData &&
                  userData.restaurant_id &&
                  userData.restaurant_id.highchair) ||
                (userData &&
                  userData.restaurant_id &&
                  userData.restaurant_id.handicap) ? (
                  <>
                    <div className="d-flex align-items-center pb-4">
                      <div className="f16-500">
                        Need Handicap access or a Highchair?
                      </div>
                      <div className="d-flex align-items-center py-4 pl-md-4">
                        <div className="f16-500 mr-2">No</div>
                        <Switch
                          onChange={handleChangeSwitch}
                          checked={checkedBox.checkedBox}
                          offColor="#EEEEEE"
                          onColor="#EEEEEE"
                          offHandleColor="#212121"
                          onHandleColor="#59F832"
                          handleDiameter={24}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={15}
                          width={41}
                          boxShadow="-2px 0px 5px #0000003B"
                          activeBoxShadow="-2px 0px 5px #0000003B"
                          id="material-switch"
                          // disabled={disabled === true ? true : false}
                        />
                        <div className="f16-500 ml-2">Yes</div>
                      </div>
                    </div>
                  </>
                ) : (
                  <> </>
                )}
              </>
              {checkedBox.checkedBox === false ? null : (
                <div className="d-flex enPartySize pb-4">
                  <div className="d-flex pr-3 pb-3">
                    <div className="enKidsIcon">
                      <Image
                        src={require("../../../../../assets/images/ActionImages/wheelchair.png")}
                        alt="View"
                        title="View"
                        className="custom"
                      />
                    </div>
                    <div className="pl-md-2 enPartyPersonEdit">
                      <div className="f14-500 pb-2">Handicap</div>
                      <div className="d-flex align-items-center">
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={DecreaseHandicapItem}
                        >
                          <Image
                            src={require("../../../../../assets/images/UserManagement/minus.svg")}
                            alt="Minus"
                            title="Minus"
                            fluid
                          />
                        </Button>
                        <input
                          placeholder="00"
                          className="enInputValueOnly f12-700"
                          value={handicap}
                          readOnly
                        />
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={IncrementhandicapItem}
                        >
                          <Image
                            src={require("../../../../../assets/images/UserManagement/plus.svg")}
                            alt="Minus"
                            title="Minus"
                            fluid
                          />
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex border-left pl-3 pb-3">
                    <div className="enKidsIcon">
                      <Image
                        src={require("../../../../../assets/images/ActionImages/highchair.svg")}
                        alt="View"
                        title="View"
                        className="custom"
                      />
                    </div>
                    <div className="pl-md-2 enPartyPersonEdit">
                      <div className="f14-500 pb-2">Highchair</div>
                      <div className="d-flex align-items-center">
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={DecreaseHighchairItem}
                        >
                          <Image
                            src={require("../../../../../assets/images/UserManagement/minus.svg")}
                            alt="Minus"
                            title="Minus"
                            fluid
                          />
                        </Button>
                        <input
                          placeholder="00"
                          className="enInputValueOnly f12-700"
                          value={highchair}
                          readOnly
                        />
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={IncrementhighchairItem}
                        >
                          <Image
                            src={require("../../../../../assets/images/UserManagement/plus.svg")}
                            alt="Minus"
                            title="Minus"
                            fluid
                          />
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <Row>
                <Col md={5}>
                  <Form.Group>
                    <TextField
                      id="outlined-basic"
                      label="Room No."
                      variant="outlined"
                      className="w-100"
                      value={state.roomNumber}
                      onChange={onChangeNumber}
                      type="number"
                      onKeyDown={InputNumberFunc}
                      inputProps={{
                        name: "roomNumber",
                        maxLength: 3,
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md={5}>
                  <Form.Group>
                    <TextField
                      id="outlined-basic"
                      label="Table No."
                      variant="outlined"
                      className="w-100"
                      value={state.tableNumber}
                      onChange={onChangeNumber}
                      type="number"
                      onKeyDown={InputNumberFunc}
                      inputProps={{
                        name: "tableNumber",
                        maxLength: 3,
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className="f16-500 pb-1 pt-3">Seating Preference</div>
                  <div className="f12-400 pb-3">
                    Seating is a subject to availability. Your Preference will
                    be considered.
                  </div>
                </Col>
                {/* {seatingPreference.map((item, index) => (
                  <Col md={4} key={index}>
                    <div className="enCheckWithText w-100">
                      <input
                        type="radio"
                        name="SeatingPreference"
                        onChange={() => onChangeSeatingPreference(item.title)}
                        checked={item.title === state.seating_preference}
                      />
                      <label className="w-100 d-flex align-items-center justify-content-center">
                        {item.title}
                      </label>
                    </div>
                  </Col>
                ))} */}

                {seatingPreference.map((item, index) => (
                  <Col md={4} key={index}>
                    <div className="enCheckWithText w-100">
                      <input
                        type="radio"
                        name="SeatingPreference"
                        onChange={() => onChangeSeatingPreference(item.title)}
                        checked={item.title === state.seating_preference}
                      />
                      <label className="w-100 d-flex align-items-center justify-content-center">
                        {item.icon ? (
                          <Image
                            src={item.icon}
                            alt="img"
                            title="img"
                            className="mr-2 w-20px"
                          />
                        ) : (
                          <> </>
                        )}
                        {item.title}
                      </label>
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
            <Col md={12}>
              <div className="f16-500 pt-3 pb-2">Special Occasion</div>
              <Form.Group>
                <TextField
                  id="outlined-multiline-static"
                  multiline
                  rows={5}
                  placeholder="eg. Wedding Anniversary"
                  variant="outlined"
                  className="w-100"
                  value={state.specialOcassion}
                  onChange={onChange}
                  type="text"
                  inputProps={{
                    name: "specialOcassion",
                  }}
                />
              </Form.Group>
              <div className="d-flex align-items-center pt-4">
                <Button
                  variant="outline-secondary"
                  className="f18-500 btn-lg mr-4 px-5"
                  onClick={onClickCloseEdit}
                >
                  Cancel
                </Button>
                <Button
                  variant="danger"
                  className="f18-500 btn-lg px-5"
                  //onClick={onClickCloseEdit}
                  onClick={() => onClickUpdate()}
                >
                  Update
                </Button>
              </div>
            </Col>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

EditDiner.propTypes = {
  auth: PropTypes.object.isRequired,
  vendor_dashboard_edit_action: PropTypes.func.isRequired,
  getUserDetailsFromUserId: PropTypes.func.isRequired,
  getUserDetailsByType: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  vendor_dashboard_edit_action,
  getUserDetailsFromUserId,
  getUserDetailsByType,
})(EditDiner);
